import { withStandardBaseCssClass } from '@adobe/aem-core-components-react-spa'
import { ComponentMapping, Container, ContainerState } from '@adobe/aem-react-editable-components'

import ReactAuthorableModal from './ReactAuthorableModal'
import { AemModalTypes, ReactModalProps } from './types'
import IsInEditorText from '../shared/IsInEditorText'

const MODAL_CONFIG: { [key: string]: any } = {
  basicModal: ReactAuthorableModal
}
class ReactModal extends Container<ReactModalProps, ContainerState> {
  constructor(props: ReactModalProps) {
    super(props)
    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping
    }
  }

  get containerAttributes() {
    const attrs = this.containerProps
    attrs['className'] = attrs.className + ' ' + this.props.baseCssClass
    attrs['data-cmp-is'] = 'container'
    attrs['data-panelcontainer'] = 'container'
    attrs['data-testid'] = 'reactcontainer'
    return attrs
  }

  render() {
    const { modal = AemModalTypes.basicModal, isInEditor = false, baseCssClass, modalId = '' } = this.props
    const embedObject = this.props.cqItems?.embed
    const Component = MODAL_CONFIG[modal]
    return (
      <>
        {IsInEditorText(isInEditor, `(${modalId}) Modal`)}
        <div {...this.containerAttributes} className='container'>
          <div className={`${baseCssClass}`}>
            {isInEditor && this.childComponents}
            {isInEditor && this.placeholderComponent}
            {Component ? (
              <Component {...this.props}>
                {this.childComponents}
                {this.placeholderComponent}
              </Component>
            ) : null}
          </div>
          {/* CCCOREUI-3122: below code will add hidden div to prevent the scroll to top in the modal backfrop */}
          {/* CCCOREUI-3484: don't load the youtube files ahead */}
          {!isInEditor && (!embedObject || !Object.hasOwn(embedObject, 'youtubeVideoId')) && (
            <div style={{ display: 'none' }}>
              {this.childComponents}
              {this.placeholderComponent}
            </div>
          )}
        </div>
      </>
    )
  }
}

export default withStandardBaseCssClass(ReactModal, 'cmp-modal')
